import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const ProfileIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g fill={color}>
          <path
            d="M25.75 15.75c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-11.333 1a2.667 2.667 0 0 0-2.667 2.667c0 .736.597 1.333 1.333 1.333h5.334c.736 0 1.333-.597 1.333-1.333a2.667 2.667 0 0 0-2.667-2.667h-2.666Zm1.333-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            opacity=".12"
          />
          <path d="M15.75 6.5a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM5 15.75C5 9.813 9.813 5 15.75 5S26.5 9.813 26.5 15.75 21.687 26.5 15.75 26.5 5 21.687 5 15.75Zm9.417 1.75a1.917 1.917 0 0 0-1.917 1.917c0 .322.261.583.583.583h5.334a.583.583 0 0 0 .583-.583 1.917 1.917 0 0 0-1.917-1.917h-2.666ZM11 19.417A3.417 3.417 0 0 1 14.417 16h2.666a3.417 3.417 0 0 1 3.417 3.417c0 1.15-.933 2.083-2.083 2.083h-5.334A2.083 2.083 0 0 1 11 19.417Zm3.5-7.667a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM15.75 9a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z" />
        </g>
      </g>
    </svg>
  );
};
